import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" Component={Home} />
        {/* All content is now in the single-page Home component */}
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
